// Selling plan management
(() => {
  if (!window.location.pathname.includes('/products/')) return;

  let savedBadge = null;
  let isInitialized = false;
  let listenersAttached = false;
  let currentVariant = new URLSearchParams(location.search).get('variant');
  let badgeWatcher = null;
  let widgetWatcher = null;
  let cachedElements = {};

  const getWidget = () => cachedElements.widget || (cachedElements.widget = document.querySelector('.appstle_sub_widget'));
  const hasWidget = () => !!getWidget();

  const getElements = () => {
    if (!cachedElements.badge || !document.body.contains(cachedElements.badge)) {
      cachedElements.badge = document.querySelector('.appstle-text-and-badge-wrapper');
      cachedElements.oneTime = document.querySelector('input[id="appstle_selling_plan_label_10"]');
      cachedElements.subscribe = document.querySelector('input[id="appstle_selling_plan_label_20"]');
    }
    return cachedElements;
  };

  const wait = (selector, callback, timeout = 2000) => {
    const check = setInterval(() => {
      if (document.querySelector(selector)) {
        clearInterval(check);
        callback();
      }
    }, 150);
    setTimeout(() => clearInterval(check), timeout);
  };

  const freezeBadge = () => {
    if (!hasWidget()) return;
    const { badge } = getElements();
    if (badge) savedBadge = badge.innerHTML;
  };

  const restoreBadge = () => {
    if (!hasWidget()) return;
    const { badge } = getElements();
    if (badge && savedBadge && badge.innerHTML !== savedBadge) badge.innerHTML = savedBadge;
  };

  const forceRestore = () => {
    if (!hasWidget()) return;
    let count = 0;
    const interval = setInterval(() => {
      restoreBadge();
      if (++count >= 8) clearInterval(interval);
    }, 60);
  };

  const setSellingPlan = (useSellingPlan) => {
    if (!window.Abra || !hasWidget()) return;
    window.Abra.useSellingPlanPriceOnProductBlock = useSellingPlan;
    window.Abra.render();
    forceRestore();
  };

  const detectState = () => {
    if (!hasWidget()) return;
    setTimeout(() => {
      const { oneTime } = getElements();
      if (oneTime?.checked) setTimeout(() => setSellingPlan(false), 100);
    }, 100);
  };

  const initialize = (isReinit = false) => {
    if (!hasWidget() || (!isReinit && isInitialized)) return;

    wait('.appstle_subscription_amount_wrapper', () => {
      if (!hasWidget() || !window.Abra) return;
      
      setTimeout(() => {
        window.Abra.useSellingPlanPriceOnProductBlock = true;
        window.Abra.render();

        setTimeout(() => {
          if (isReinit) {
            savedBadge = null;
            cachedElements = {};
          }
          freezeBadge();
          
          setTimeout(() => {
            if (!isReinit) startWatcher();
            detectState();
          }, 300);
        }, isReinit ? 400 : 800);
      }, isReinit ? 250 : 400);
    });

    if (!isReinit) isInitialized = true;
  };

  const startWatcher = () => {
    if (!hasWidget() || badgeWatcher) return;
    badgeWatcher = setInterval(() => {
      if (!hasWidget()) return clearInterval(badgeWatcher);
      restoreBadge();
    }, 300);
  };

  const handleVariantChange = () => {
    const newVariant = new URLSearchParams(location.search).get('variant');
    if (newVariant && newVariant !== currentVariant) {
      currentVariant = newVariant;
      if (badgeWatcher) clearInterval(badgeWatcher);
      badgeWatcher = null;
      isInitialized = false;
      cachedElements = {};
      setTimeout(() => initialize(true), 250);
    }
  };

  const init = () => {
    if (!hasWidget()) return;
    
    const { oneTime, subscribe } = getElements();
    if (!oneTime || !subscribe) return;

    initialize();

    if (listenersAttached) return;
    
    window.addEventListener('popstate', handleVariantChange);
    const form = document.querySelector('form[action*="/cart/add"]');
    if (form) form.addEventListener('change', handleVariantChange);
    
    oneTime.addEventListener('change', () => setSellingPlan(false));
    subscribe.addEventListener('change', () => setSellingPlan(true));
    
    const labelOne = document.querySelector('label[for="appstle_selling_plan_label_10"]');
    const labelSub = document.querySelector('label[for="appstle_selling_plan_label_20"]');
    if (labelOne) labelOne.addEventListener('click', () => setTimeout(() => setSellingPlan(false), 10));
    if (labelSub) labelSub.addEventListener('click', () => setTimeout(() => setSellingPlan(true), 10));
    
    listenersAttached = true;
  };

  const startWidgetWatcher = () => {
    if (widgetWatcher) clearInterval(widgetWatcher);
    let attempts = 0;
    widgetWatcher = setInterval(() => {
      if (hasWidget() && !isInitialized) {
        init();
        clearInterval(widgetWatcher);
      } else if (++attempts >= 40) {
        clearInterval(widgetWatcher);
      }
    }, 250);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hasWidget() ? init() : startWidgetWatcher());
  } else {
    setTimeout(() => hasWidget() ? init() : startWidgetWatcher(), 100);
  }
})();